import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_input_number = _resolveComponent("a-input-number");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[13] || (_cache[13] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "基本信息"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "客户代码",
                  rules: [{
                    required: true,
                    message: '请输入客户代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fCustNumber,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.fCustNumber = $event),
                    allowClear: "true",
                    onChange: _cache[1] || (_cache[1] = e => $setup.OnFieldChange(e, ''))
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustName",
                  label: "客户名称"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    style: {
                      "width": "100%"
                    },
                    "show-search": "",
                    "filter-option": false,
                    onSearch: _cache[2] || (_cache[2] = e => $setup.GetExtendData(e)),
                    onChange: _cache[3] || (_cache[3] = e => $setup.OnFieldChange1(e)),
                    placeholder: "请选择客户名称",
                    options: $setup.DMConfig.ExtendData,
                    value: $setup.DMConfig.Model.fCustId,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.DMConfig.Model.fCustId = $event),
                    allowClear: true
                  }, null, 8, ["options", "value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fNumber",
                  label: "K3物料代码",
                  rules: [{
                    required: true,
                    message: '请输入K3物料代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fNumber,
                    "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.DMConfig.Model.fNumber = $event),
                    onChange: _cache[6] || (_cache[6] = e => $setup.OnFieldChange(e, '')),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fName",
                  label: "K3物料名称"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.fName), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fModel",
                  label: "K3物料规格"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.fModel), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fbursonProCode",
                  label: "Customer Pro Code"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fbursonProCode,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => $setup.DMConfig.Model.fbursonProCode = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fProductNumber",
                  label: "Product Number",
                  rules: [{
                    required: true,
                    message: '请输入Product Number!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fProductNumber,
                    "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.DMConfig.Model.fProductNumber = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fDescription",
                  label: "Description of Goods",
                  rules: [{
                    required: true,
                    message: '请输入Description of Goods!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fDescription,
                    "onUpdate:value": _cache[9] || (_cache[9] = $event => $setup.DMConfig.Model.fDescription = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fColor",
                  label: "Color"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fColor,
                    "onUpdate:value": _cache[10] || (_cache[10] = $event => $setup.DMConfig.Model.fColor = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fElectric",
                  label: "Electric"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fElectric,
                    "onUpdate:value": _cache[11] || (_cache[11] = $event => $setup.DMConfig.Model.fElectric = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fPrice",
                  label: "Unit Price",
                  rules: [{
                    required: true,
                    message: '请输入Unit Price!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_number, {
                    value: $setup.DMConfig.Model.fPrice,
                    "onUpdate:value": _cache[12] || (_cache[12] = $event => $setup.DMConfig.Model.fPrice = $event),
                    formatter: value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    parser: value => value.replace(/\$\s?|(,*)/g, '')
                  }, null, 8, ["value", "formatter", "parser"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_row, {
                gutter: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_col, {
                  md: 20,
                  sm: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_form_item, {
                    name: "fDate",
                    label: "Date"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.fDate), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_col, {
                  md: 20,
                  sm: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_form_item, {
                    name: "fModifyDate",
                    label: "date updated"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.fModifyDate), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "onOk"]);
}